import React, { useEffect, useState } from 'react';
import { XIcon, PhoneIcon, UserIcon } from 'lucide-react';
interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ContactModal({
  isOpen,
  onClose
}: ContactModalProps) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [submitted, setSubmitted] = useState(false);
  // Reset form state every time modal opens
  useEffect(() => {
    if (isOpen) {
      setName('');
      setPhone('');
      setSubmitted(false);
    }
  }, [isOpen]);
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-1">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-navy/80 backdrop-blur-sm" data-id="element-2"></div>

      {/* Modal */}
      <div className="relative bg-[#f5edd8] shadow-2xl max-w-md w-full border-4 border-orange" style={{
      border: '4px solid #ff571e'
    }} onClick={e => e.stopPropagation()} data-id="element-3">
        {/* Tape strips */}
        <div className="absolute -top-3 left-10 w-16 h-5 opacity-70 rounded-sm z-10" style={{
        background: 'rgba(255,245,180,0.85)',
        transform: 'rotate(-5deg)',
        boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
      }} data-id="element-4"></div>
        <div className="absolute -top-3 right-10 w-16 h-5 opacity-70 rounded-sm z-10" style={{
        background: 'rgba(255,245,180,0.85)',
        transform: 'rotate(4deg)',
        boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
      }} data-id="element-5"></div>

        {/* Header */}
        <div className="bg-navy px-6 py-4 flex items-center justify-between" data-id="element-6">
          <div data-id="element-7">
            <p className="text-orange font-sub text-sm uppercase tracking-widest" data-id="element-8">
              Free Estimate
            </p>
            <h2 className="text-cream font-display text-2xl" data-id="element-9">GET IN TOUCH</h2>
          </div>
          <button onClick={onClose} className="text-cream hover:text-orange transition-colors p-1" aria-label="Close" data-id="element-10">
            <XIcon className="h-6 w-6" data-id="element-11" />
          </button>
        </div>

        {/* Body */}
        <div className="p-8" data-id="element-12">
          {submitted ? <div className="text-center py-6" data-id="element-13">
              <div className="text-orange text-6xl font-display mb-4" data-id="element-14">✓</div>
              <h3 className="text-navy font-display text-2xl mb-2" data-id="element-15">GOT IT!</h3>
              <p className="text-brown font-body" data-id="element-16">
                We'll give you a call shortly. Thanks for reaching out!
              </p>
              <button onClick={onClose} className="mt-6 bg-orange text-white px-8 py-3 font-sub text-lg uppercase tracking-wide hover:bg-orange-600 transition-colors" data-id="element-17">
                Close
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-18">
              <p className="text-brown font-body text-sm mb-4" data-id="element-19">
                Leave your info and we'll call you back fast — usually same day.
              </p>

              <div data-id="element-20">
                <label className="block font-sub text-navy uppercase tracking-wide text-sm mb-1" data-id="element-21">
                  Full Name
                </label>
                <div className="relative" data-id="element-22">
                  <UserIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-brown/40" data-id="element-23" />
                  <input type="text" required value={name} onChange={e => setName(e.target.value)} placeholder="John Smith" className="w-full pl-10 pr-4 py-3 bg-cream border-2 border-tan focus:border-orange outline-none font-body text-brown placeholder:text-brown/30 transition-colors" data-id="element-24" />
                </div>
              </div>

              <div data-id="element-25">
                <label className="block font-sub text-navy uppercase tracking-wide text-sm mb-1" data-id="element-26">
                  Phone Number
                </label>
                <div className="relative" data-id="element-27">
                  <PhoneIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-brown/40" data-id="element-28" />
                  <input type="tel" required value={phone} onChange={e => setPhone(e.target.value)} placeholder="(602) 555-0100" className="w-full pl-10 pr-4 py-3 bg-cream border-2 border-tan focus:border-orange outline-none font-body text-brown placeholder:text-brown/30 transition-colors" data-id="element-29" />
                </div>
              </div>

              <button type="submit" className="w-full bg-orange hover:bg-orange-600 text-white py-4 font-sub text-xl uppercase tracking-wide transition-colors shadow-[4px_4px_0px_0px_rgba(26,58,92,0.3)] hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px] transition-all" data-id="element-30">
                Request a Call Back
              </button>

              <p className="text-center text-brown/50 font-body text-xs" data-id="element-31">
                Or call us directly:{' '}
                <a href="tel:6025842141" className="text-orange font-bold" data-id="element-32">
                  602-584-2141
                </a>
              </p>
            </form>}
        </div>
      </div>
    </div>;
}